import { pick } from 'es-toolkit';

import { SimpleObject } from '@clearverify/types';

import { ActiveInactive, EmployeeRegistrationMutationVariables } from 'src/api';
import { EmployeeBasicInfoFormField } from 'src/constants/signup';
import { EmployeeBasicInfoFormValues } from 'src/types/signup';

export const prepareFormDataConsumer = (
  formData: SimpleObject,
  employeeSignupToken: string,
): EmployeeRegistrationMutationVariables => {
  const userData = pick(
    formData,
    Object.keys(EmployeeBasicInfoFormField),
  ) as EmployeeBasicInfoFormValues;

  return {
    employeeSignupToken,
    requestAutoApprove: formData.isAutoVerificationRequestEnabled !== ActiveInactive.Inactive,
    user: {
      email: userData.email,
      firstName: userData.firstName,
      lastName: userData.lastName,
      phoneNumber: userData.phoneNumber,
      password: String(userData.password),
      ...userData.homeAddress,
    },
  };
};
